import api, { apiWrapper } from '../api/axios';

export const getAdminProfile = async () => {
  return apiWrapper(() => api.get('/admin/profile/'));
};

export const updateAdminProfile = async (data) => {
  return apiWrapper(() => api.patch('/admin/profile/', data));
};

